module.exports = __webpack_public_path__ + "img/shop.6801be40.png";